module.exports = __webpack_public_path__ + "img/f5dbf86.png";